import handleize from './handleize';

const generateUrl = (category) => {
  if (category.data?.Handle?.value) {
    return `/collections/${category.data.Handle.value}`;
  }

  return `/collections/${handleize(category.displayName)}`;
};

export function searchOverlayCategoryItems(categories, query, facets) {
  let html = '';

  if (categories) {
    categories.forEach((category) => {
      const categoryFacet = facets?.nodes?.find((i) => i.category.categoryId === category.categoryId);

      const item = `
        <a class="tw-py-3 tw-gap-2 flex justify-between border-b border-warm-gray-100 no-underline"
           href="${generateUrl(category)}">
          <span>
          ${category.displayName.replaceAll(new RegExp(String.raw`${query}`, 'gi'), `<strong>${query}</strong>`)}
</span>
<span class="text-[#78716C]">${categoryFacet ? theme.strings.searchCategoryItemPcs.replace('COUNT', categoryFacet.hits) : ''}</span>
        </a>
      `;

      html += item;
    });
  }

  return html;
}

export function searchPageCategoryItems(categories) {
  let html = '';

  if (categories) {
    categories.forEach((category) => {
      const item = `
        <a class="w-1/2 sm:w-auto sm:mr-16 my-4 text-sm md:text-base md:font-semibold no-underline block"
           href="${generateUrl(category)}">
          ${category.displayName}
        </a>
      `;

      html += item;
    });
  }

  return html;
}
